var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
var EmojiActive = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { x: "0", y: "0", width: "18", height: "18", rx: "3" }),
            React.createElement("path", { d: "M9,16.5 C13.1421356,16.5 16.5,13.1421356 16.5,9 C16.5,4.85786438 13.1421356,1.5 9,1.5 C4.85786438,1.5 1.5,4.85786438 1.5,9", stroke: "#00ADEE", strokeLinecap: "round", transform: "translate(9.000000, 9.000000) rotate(90.000000) translate(-9.000000, -9.000000) " }),
            React.createElement("circle", { fill: "#00ADEE", cx: "6", cy: "7", r: "1" }),
            React.createElement("circle", { fill: "#00ADEE", cx: "12", cy: "7", r: "1" }),
            React.createElement("rect", { fill: "#00ADEE", x: "0", y: "3", width: "7", height: "1", rx: "0.5" }),
            React.createElement("rect", { fill: "#00ADEE", x: "3", y: "0", width: "1", height: "7", rx: "0.5" }),
            React.createElement("path", { d: "M12.4645556,10.5 C11.8673108,10.5 11.3690739,10.5 9,10.5 C6.63092763,10.5 6.13268989,10.5 5.53544561,10.5 C5.77805926,12.1961471 7.23676405,13.5 9,13.5 C10.763236,13.5 12.2219407,12.1961471 12.4645556,10.5 Z", stroke: "#00ADEE" }))));
};
export default EmojiActive;
